document.addEventListener('DOMContentLoaded', () => {
  // Збираємо всі <details> в будь-якому контейнері з класом .accordion
  document.querySelectorAll('.accordion details').forEach(details => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.accordion__content');

    // При першому рендері, якщо <details> відкритий, відразу встановлюємо висоту
    if (details.open) {
      content.style.height = content.scrollHeight + 'px';
    }

    summary.addEventListener('click', e => {
      e.preventDefault();
      const isOpening = !details.open;

      if (isOpening) {
        // ————— ВІДКРИТТЯ —————
        details.open = true;               // відкрити тег
        content.style.height = '0px';      // старт із нульової висоти

        requestAnimationFrame(() => {
          // анімація до повної висоти
          content.style.height = content.scrollHeight + 'px';
        });

        // Після анімації скидаємо inline-стиль, щоб контент міг адаптуватись
        content.addEventListener('transitionend', function handler(evt) {
          if (evt.propertyName === 'height') {
            content.style.height = 'auto';
            content.removeEventListener('transitionend', handler);
          }
        });
      } else {
        // ————— ЗАКРИТТЯ —————
        // Фіксуємо поточну висоту блоку
        content.style.height = content.scrollHeight + 'px';

        requestAnimationFrame(() => {
          // анімація до нуля
          content.style.height = '0px';
        });

        // Коли анімація скінчиться — прибираємо атрибут open і inline-стиль
        content.addEventListener('transitionend', function handler(evt) {
          if (evt.propertyName === 'height') {
            details.removeAttribute('open');
            content.style.height = '';
            content.removeEventListener('transitionend', handler);
          }
        });
      }
    });
  });
});

// Скролл до блоку з опціями товару
document.addEventListener('DOMContentLoaded', () => {
  const ctaButtons = document.querySelectorAll('a.button--primary[href="/products/injection-care-serum"]');

  // Плавний скрол з урахуванням відступу зверху (headerOffset)
  function smoothScrollTo(el, duration = 800, headerOffset = 0) {
    const startY   = window.pageYOffset;
    const rect     = el.getBoundingClientRect();
    const targetY  = startY + rect.top - headerOffset;
    const distance = targetY - startY;
    let startTime;

    function step(timestamp) {
      if (!startTime) startTime = timestamp;
      const time     = timestamp - startTime;
      const progress = Math.min(time / duration, 1);
      const ease     = progress < 0.5
        ? 2 * progress * progress
        : -1 + (4 - 2 * progress) * progress;

      window.scrollTo(0, startY + distance * ease);

      if (time < duration) {
        requestAnimationFrame(step);
      }
    }

    requestAnimationFrame(step);
  }

  ctaButtons.forEach(button => {
    button.addEventListener('click', e => {
      e.preventDefault();

      const variantSection = document.querySelector('.variant-cards-wrapper');
      if (!variantSection) return; // Вихід, якщо блоку немає

      const headerEl     = document.querySelector('header.header') || document.querySelector('.header-wrapper');
      const headerOffset = headerEl ? headerEl.offsetHeight : 0;

      smoothScrollTo(variantSection, 800, headerOffset + 16);

      // (Не обов’язково — залишено для сумісності)
      const checkedInput = variantSection.querySelector('input[type="radio"]:checked');
      const firstInput   = variantSection.querySelector('input[type="radio"]');
      const targetInput  = checkedInput || firstInput;
      if (targetInput) {
        setTimeout(() => targetInput.focus(), 800);
      }
    });
  });
});

/*
// Додавання товару до кошика
document.addEventListener('DOMContentLoaded', function () {
  // Знаходимо всі кнопки з потрібним посиланням
  const productLinks = document.querySelectorAll('a.button.button--primary[href^="/products/"]');

  productLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault(); 

      
      const addToCartBtn = document.querySelector('#ProductSubmitButton-template--15537929683002__main');

      if (addToCartBtn) {
        addToCartBtn.click();
      }
    });
  });
});
*/

/*
document.addEventListener('DOMContentLoaded', function () {
  const labels = document.querySelectorAll('.product-form__input--pill label');

  // Додаємо бейдж
  labels.forEach(label => {
    if (label.textContent.includes('3') && !label.querySelector('.badge-discount')) {
      const badge = document.createElement('span');
      badge.className = 'badge-discount';
      badge.textContent = 'Save 20%';
      label.appendChild(badge);
    }
  });
});
*/

/*
document.addEventListener('DOMContentLoaded', function () {
  const container = document.querySelector('.product-form__input--pill'); // блок з радіо
  const labels = document.querySelectorAll('.product-form__input--pill label');
  const radios = Array.from(container.querySelectorAll('input[type="radio"]'));
  
  if (radios.length !== 3) return;

  // Беремо пари інпут + label
  const items = radios.map(radio => {
    const label = container.querySelector(`label[for="${radio.id}"]`);
    return { radio, label };
  });

  // Новий порядок: 1, 2, 0
  const newOrder = [items[1], items[2], items[0]];

  // Вставляємо у новому порядку
  newOrder.forEach(({ radio, label }) => {
    container.appendChild(radio);
    container.appendChild(label);
  });

  // Додаємо бейдж
  labels.forEach(label => {
    if (label.textContent.includes('Most Popular') && !label.querySelector('.badge-discount')) {
      const badge = document.createElement('span');
      badge.className = 'badge-discount';
      badge.textContent = 'Save 20%';
      label.appendChild(badge);
    }
  });
});
*/